import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import GAErrorDetailsPopup from 'apps/auth/components/ga/accounts/send/popups/GAErrorDetailsPopup';
import ErrorDetailsPopup from 'apps/auth/components/send/popups/errors/ErrorDetailsPopup';
import { SENDING_LIMIT_ACHIEVE } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { LIMIT_TYPE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { INDIVIDUAL } from 'apps/auth/constants/amplitude/AmplitudeParamValues';

import { CurrencyPanel } from './CurrencyPanel';
import ErrorDetails from './ErrorDetails';

const SendInfoPanelPureComponent = (props) => {
    const popupRef = useRef(null);
    const isAdditionalSendingLimits = props.additionalAmlLimit && props.amountField.value > props.additionalAmlLimit.left;

    const sendAmplitudeEvent = () => {
        if (isAdditionalSendingLimits) {
            amplitude.getInstance().logEvent(SENDING_LIMIT_ACHIEVE, {
                [LIMIT_TYPE]: props.additionalAmlLimit?.limitSubType,
            });
        } else if (props.isProfileLimits) {
            amplitude.getInstance().logEvent(SENDING_LIMIT_ACHIEVE, {
                [LIMIT_TYPE]: INDIVIDUAL,
            });
        }
    };

    const Component = props.isGaFlow ? GAErrorDetailsPopup : ErrorDetailsPopup;
    return (
        <>
            {props.amountField.isError ? (
                <ErrorDetails
                    isGaFlow={props.isGaFlow}
                    amountField={props.amountField}
                    isShowErrorDetails={props.isShowErrorDetails.current}
                    text={props.currency.code}
                    errorMessage={props.amountField.errorMessage}
                    onClick={(e) => {
                        e.preventDefault();
                        sendAmplitudeEvent();
                        popupRef.current?.open(
                            <Component
                                isBonus={props.isBonus}
                                maxAmount={props.restriction.maxAmount}
                                multiple={props.restriction.multiple}
                                currencyCode={props.restriction.ccyIso}
                                currencyCodeFrom={props.restrictionFrom.ccyIso}
                                isFrom={props.isFrom}
                                amountField={props.amountField}
                                decreaseAmountButtonClick={props.decreaseAmountButtonClick}
                                formName={props.formName}
                                popupRef={popupRef}
                                sendAmplitudeEvent={props.sendFlowV3 ? sendAmplitudeEvent : null}
                            />,
                        );
                    }}
                />
            ) : (
                <CurrencyPanel
                    currencies={props.currencies}
                    currency={props.currency}
                    ccyField={props.ccyField}
                    onSelectCurrencyClick={props.onSelectCurrencyClick}
                    iconName={props.iconName}
                />
            )}
            <PopupNew ref={popupRef} />
        </>
    );
};

SendInfoPanelPureComponent.propTypes = {
    isBonus: PropTypes.bool,
    currencies: PropTypes.array.isRequired,
    currency: PropTypes.object,
    ccyField: PropTypes.object.isRequired,
    newBalanceText: PropTypes.string,
    pocketBalance: PropTypes.number,
    amountField: PropTypes.object.isRequired,
    isShowErrorDetails: PropTypes.object.isRequired,
    restriction: PropTypes.object.isRequired,
    onSelectCurrencyClick: PropTypes.func.isRequired,
    decreaseAmountButtonClick: PropTypes.func.isRequired,
};

export const SendInfoPanel = SendInfoPanelPureComponent;
